import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail-done",
  "use": "icon-detail-done-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 90 90\" id=\"icon-detail-done\"><defs><style>#icon-detail-done .a{fill:rgba(243,244,245,0);}#icon-detail-done .b,#icon-detail-done .c,#icon-detail-done .e{fill:none;}#icon-detail-done .b,#icon-detail-done .c{stroke:currentColor;stroke-width:3px;}#icon-detail-done .b{stroke-linejoin:round;}#icon-detail-done .d{stroke:none;}</style></defs><g transform=\"translate(-1410 -557)\"><rect class=\"a\" width=\"90\" height=\"90\" transform=\"translate(1410 557)\" /><g transform=\"translate(0 0.82)\"><g class=\"b\" transform=\"translate(1422 573.18)\"><rect class=\"d\" width=\"65.31\" height=\"55.641\" /><rect class=\"e\" x=\"-1.5\" y=\"-1.5\" width=\"68.31\" height=\"58.641\" /></g><line class=\"c\" x2=\"67.949\" transform=\"translate(1421.5 590.104)\" /><path class=\"c\" d=\"M0,16.969,16.97,0,28.812,11.351\" transform=\"translate(1469.641 617.952) rotate(180)\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/detail-done.svg
// module id = 4R6P
// module chunks = 82